








import Vue from "vue";
export default Vue.extend({
  name: "indicator",
  props: ["pass"],
  data: () => ({
      colors: ['green','yellow','red'],
      icons: ['mdi-check','mdi-alert-outline','mdi-alpha-x-circle-outline'],
      texts: ['contraseña segura','contraseña poco segura','contraseña insegura'],
      ind: 2
  }),
  computed:{
      verify(){
          if(this.pass.length >= 12 ){
              if(this.haveanumber && this.haveaspecial && this.haveamayus){
                  return 0
              }
              else {
                  return 1
              }
          }
          else if(this.pass.length < 12 && this.pass.length > 6){
              if(this.haveanumber && this.haveaspecial && this.haveamayus){
                  return 1
              }
              else{
                  return 2
              }
          }
          else{
              return 2
          }
      },
      haveatext(){
          let com = /[a-zA-Z]/.test(this.pass)
          return com;
      },
      haveanumber(){
          let com = /[0-9]/.test(this.pass)
          return com;
      },
      haveaspecial(){
          let com = /\w/.test(this.pass)
          return com;
      },
      haveamayus(){
          let com = /[A-Z]/.test(this.pass)
          return com;
      },
  },
});
